import React from "react";
import Header from "../components/Hearder";
import Footer from "../components/Footer";
import PlansHeroSection from "./components/PlansHeroSection";
import BusinessTypeSelector from "./components/BusinessTypeSelector";
import WorkForFreeSection from "./components/WorkForFreeSection";
import PricingPlansSection from "./components/PricingPlansSection";
import AddOnsSection from "./components/AddOnsSection";
import ConsultationSection from "./components/ConsultationSection";
import Partners from "../components/Partners";
import ClientFeedbackSection from "./components/ClientFeedbackSection";
import TestimonialsSection from "../components/TestimonialsSection";

function PlansPage() {
  return (
    <div className="font-sans text-gray-800">
      <Header />
      <main>
        <PlansHeroSection />
        <BusinessTypeSelector />
        <PricingPlansSection />
        <WorkForFreeSection />
        <Partners />
        <AddOnsSection />
        <ConsultationSection />
        <ClientFeedbackSection />
        <TestimonialsSection/>
        {/* Otras secciones de precios se pueden agregar aquí */}
      </main>
      <Footer />
    </div>
  );
}

export default PlansPage;
